import { Outlet } from "react-router";

import { ChatWidgetPublic } from "@features/ChatWidget";

export const PublicShell = () => (
	<>
		<Outlet />
		<ChatWidgetPublic />
	</>
);
